<template>
  <tr>
    <td>{{ moviment.generationDate }}</td>
    <td class="text-center">
      <span class="badge badge-rent" v-if="moviment.statusMovimentName === 'Saída'">Saída</span>
      <span class="badge badge-returned" v-if="moviment.statusMovimentName === 'Retorno'">Retorno</span>
    </td>
    <td class="text-center">{{ moviment.generationUser }}</td>
    <td class="text-center">{{ moviment.description || 'N/I' }}</td>
    <td class="text-right">
      <MovimentButtons
        :moviment="moviment"
        @print="$emit('print', $event)"
        @attachment="$emit('attachment', $event)"
        @open-items="$emit('open-items', $event)"
        @delete="$emit('delete', $event)"
      />
    </td>
  </tr>
</template>

<script>
import MovimentButtons from "./MovimentButtons.vue";

export default {
  name: "MovimentItem",
  components: { MovimentButtons },
  props: {
    moviment: { type: Object, required: true },
  },
};
</script>

<style scoped>
.badge {
  font-size: 13px !important;
  border-radius: 10px !important;
  padding: 6px 10px;
  color: white;
}

.badge-rent {
  background-color: #009183;
}

.badge-returned {
  background-color: #b8860b;
}
</style>
